var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-field-doc-hint caption"},[(_vm.hint)?_c('span',{staticClass:"gray--text text--darken-1"},[_vm._v(_vm._s(_vm.hint))]):_vm._e(),(_vm.showDocLink)?_c('a',{staticClass:"info--text",class:{ 'ml-1': _vm.hint },attrs:{"href":_vm.docUrl,"target":"_blank","rel":"noopener"}},[_vm._v(_vm._s(_vm.linkText))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }